import { SortOrder } from '@Utils/helpers/sortingHelpers';
import {
    DownloadFilesSortField,
    FileUploadStep,
    IFileUploadHeader,
    IQcFileResult,
    IUploadedFile,
} from '@Data/files/Interfaces';

export interface IFilesState {
    fileId: string | null;
    fileHeaders: Array<IFileUploadHeader>;
    currentStep: FileUploadStep;
    selectedLatField: IFileUploadHeader;
    selectedLngField: IFileUploadHeader;
    selectedPoleIdField: IFileUploadHeader;
    workflowEngineState: string | null;
    uploadingFileNotificationIds: Array<string>;

    downloadFilesSortOrder: SortOrder;
    downloadFilesSortField: DownloadFilesSortField;
    qcFiles: Array<IQcFileResult>;
}

export const initialFilesState: IFilesState = {
    fileId: null,
    fileHeaders: [],
    currentStep: FileUploadStep.UPLOAD_FILE,
    selectedLatField: null,
    selectedLngField: null,
    selectedPoleIdField: null,
    workflowEngineState: null,
    uploadingFileNotificationIds: [],
    downloadFilesSortField: undefined,
    downloadFilesSortOrder: SortOrder.DESC,
    qcFiles: [],
};
